import React from 'react';
import PropTypes from 'prop-types';

import Value from './value';

const PropertyTypeValue = ({ source }) => {
  let value = source.propertyType;
  if (source.propertySubtype) {
    value = `${value}, ${source.propertySubtype}`;
  }

  return (
    <Value name="propertyType" value={value} />
  );
};

PropertyTypeValue.propTypes = {
  source: PropTypes.shape({
    propertyType: PropTypes.string.isRequired,
    propertySubtype: PropTypes.string,
  }),
};

export default PropertyTypeValue;
